__turbopack_context__.v({
  "dot": "NavigationDots-module-scss-module__oChVPW__dot",
  "dotActive": "NavigationDots-module-scss-module__oChVPW__dotActive",
  "dots": "NavigationDots-module-scss-module__oChVPW__dots",
});
